import { styled as e, Box as i } from "@mui/material";
import { jsxs as s, jsx as t } from "react/jsx-runtime";
const r = e(i)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`, l = e(i)`
  position: absolute;
`, h = ({
  className: o,
  children: n
}) => /* @__PURE__ */ s(r, {
  className: o,
  children: [/* @__PURE__ */ t("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "77",
    viewBox: "0 0 70 77",
    fill: "none",
    children: /* @__PURE__ */ t("path", {
      d: "M0.898438 21.5622C0.898438 17.5498 3.32431 13.9357 7.03764 12.4158L31.2564 2.50305C33.6555 1.52108 36.3445 1.52107 38.7436 2.50305L62.9624 12.4158C66.6757 13.9357 69.1016 17.5498 69.1016 21.5622V55.4378C69.1016 59.4502 66.6757 63.0643 62.9624 64.5842L38.7436 74.4969C36.3445 75.4789 33.6555 75.4789 31.2564 74.4969L7.03764 64.5842C3.32431 63.0643 0.898438 59.4502 0.898438 55.4378V21.5622Z",
      fill: "black",
      stroke: "white",
      strokeWidth: "1.79688"
    })
  }), /* @__PURE__ */ t(l, {
    children: n
  })]
});
export {
  h as default
};
//# sourceMappingURL=LevelContainer.js.map
